import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import EventFinished from "src/components/EventFinished";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import TitleSection from "src/components/TitleSection/TitleSection";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import DynamicGoogleFormSubmitter from "src/components/Form/DynamicGoogleFormSubmitter";

const NclCruiseSeptember2026Rsvp = () => {
  const { t, i18n } = useTranslation();

  return (
    <Div>
      <Hero
        bgImage="promotions/gaming-machines/ncl-cruise-september-2026/ncl-hero-image-2400x800px.jpg"
        image={`promotions/gaming-machines/ncl-cruise-september-2026/ncl-logo-2400x2400px-2-${i18n.language}.png`}
        imageAlt={t("nclCruiseSeptember2026Rsvp.hero.logoAlt")}
        title={t("nclCruiseSeptember2026Rsvp.hero.title")}
        description={t("nclCruiseSeptember2026Rsvp.hero.subtitle")}
        descriptionBgColor="#0c1d2f"
        className="ncl-hero"
        fluidImage
      />
      <EventFinished
        scheduleKeyName="nclCruiseSeptember2026Rsvp"
        eventType="promotion"
      />
      <MainContentDiv>
        <container-div>
          <TitleSection
            title="nclCruiseSeptember2026Rsvp.content.title"
            text={t("nclCruiseSeptember2026Rsvp.content.text")}
            borderColor="var(--red)"
            dark={true}
            as="h2"
            className="escape-section"
          />
        </container-div>
        <FormSection>
          <container-div>
            <TitleSection
              title="nclCruiseSeptember2026Rsvp.form.heading"
              borderColor="var(--red)"
              dark={true}
              as="h2"
              className="form-title"
            />
            <DynamicGoogleFormSubmitter
              formId="AKfycbxI15hUXwYRhLV9DPpuBVXjS3m8uj_sDC2zdq3tRvOOwQ3MkPmG4_-Fr4e4azu_XNHF_Q"
              sheetName="RSVP"
              formTextKey="nclCruiseSeptember2026Rsvp"
              titles={false}
              formFields={[
                {
                  id: "FirstName",
                  label: "firstName",
                  type: "text",
                  required: true
                },
                {
                  id: "LastName",
                  label: "lastName",
                  type: "text",
                  required: true
                },
                {
                  id: "PlayerID",
                  label: "pgPlayerId",
                  type: "text",
                  required: true,
                  placeholder: "pgPlayerIdPlaceholder"
                },
                {
                  id: "Dates",
                  label: "date",
                  type: "select",
                  required: true,
                  options: t("nclCruiseSeptember2026Rsvp.form.dateOptions", { returnObjects: true })
                }
              ]}
            />
          </container-div>
        </FormSection>
        <DetailsSection>
          <div className="details-inner">
            <div className="details-card">
              <SubTitleSection
                subTitle={t("nclCruiseSeptember2026Rsvp.eventDetails.title")}
                borderColor="var(--red)"
                dark={true}
                as="h2"
                className="details-title"
              />
              <div className="details-grid">
                <div>
                  <span className="label">
                    {t("nclCruiseSeptember2026Rsvp.eventDetails.whereLabel")}
                  </span>
                  <p>{t("nclCruiseSeptember2026Rsvp.eventDetails.whereText")}</p>
                </div>
                <div>
                  <span className="label">
                    {t("nclCruiseSeptember2026Rsvp.eventDetails.whenLabel")}
                  </span>
                  <p>{t("nclCruiseSeptember2026Rsvp.eventDetails.whenText")}</p>
                </div>
                <div>
                  <span className="label">
                    {t("nclCruiseSeptember2026Rsvp.eventDetails.timeLabel")}
                  </span>
                  <p>{t("nclCruiseSeptember2026Rsvp.eventDetails.timeText")}</p>
                </div>
              </div>
            </div>
            <div className="details-image">
              <ResponsiveImage
                src="promotions/gaming-machines/ncl-cruise-september-2026/ncl-cruise-photos-people.jpg"
                alt={t("nclCruiseSeptember2026Rsvp.eventDetails.title")}
                customStyles={{
                  width: "100%",
                  height: "100%",
                  maxWidth: "none",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        </DetailsSection>
        <container-div>
          <ReactMarkdown className="rsvp-note">
            {t("nclCruiseSeptember2026Rsvp.content.alternateRsvp")}
          </ReactMarkdown>
        </container-div>
      </MainContentDiv>
    </Div>
  );
};

const Div = styled.div`
  width: 100%;
  height: auto;
  .hero_container {
    margin-bottom: 120px;
    overflow: visible;
  }

  .ncl-hero {
    .hero_image_container {
      padding: 20px 20px 40px;
      min-height: 800px;
      background-position: top;
    }

    .hero_image {
      max-width: 820px;
      width: 100%;
    }

    .hero_text_container {
      position: relative;
      bottom: -120px;
      background-color: #0c1d2f;
      backdrop-filter: none;
      padding: 40px 20px;
      color: var(--white);
      z-index: 10;
    }

    .hero_text_container h1 {
      margin-bottom: 20px;
    }

    .hero_text_container p {
      font-size: 1rem;
      margin: 0;
    }
  }
  .escape-section {
    max-width: 880px;
    margin: 0 auto;
    h2 {
      white-space: pre-line;
    }
    p {
      font-size: 1.2rem;
      margin-top: 1rem;
    }
  }
  .escape-section strong {
    color: #1d5c8b;
  }

  .rsvp-note {
    margin: 2rem auto;
    text-align: center;
    font-size: 1.05rem;
    color: #5b5b5b;
  }

  .rsvp-note a,
  strong {
    color: #1d5c8b;
    text-decoration: none;
  }

  .rsvp-note a:hover,
  .rsvp-note a:focus {
    text-decoration: underline;
  }
  @media (max-width: 992px) {
    .hero_container {
      margin-bottom: 180px;
    }
    .ncl-hero {
      .hero_image_container {
        min-height: unset;
      }
      .hero_text_container {
        bottom: -180px;
      }
    }
  }
  @media (min-width: 1896px) {
    .rsvp-note {
      margin-top: 2rem;
    }
  }
`;

const MainContentDiv = styled.div`
  background-color: var(--white);
  width: 100%;
`;

const FormSection = styled.section`
  background-color: var(--white);
  width: 100%;
  padding: 0 0 3rem;

  .form-title {
    padding-top: 0;
    padding-bottom: 0;
  }

  .form-container {
    background-color: #0c1d2f;
    border: none;
    margin: 1.5rem auto 0;

    button {
      background: #1d5c8b;

      &:hover {
        background: var(--white);
      }
    }
  }
`;

const DetailsSection = styled.section`
  background-color: #0c1d2f;
  width: 100%;
  overflow: hidden;
  padding: 0;

  .details-inner {
    display: grid;
    align-items: center;
    width: 100%;
    margin: 0;
    gap: 0;
    grid-template-columns: minmax(0, 1fr);
  }

  .details-card {
    color: var(--white);
    padding: 2.5rem 1.5rem;
    max-width: none;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .details-title {
    padding: 0 0 1.25rem;
    width: 100%;
  }

  .details-title h2,
  .details-title h3 {
    font-weight: 800;
    font-size: clamp(1.5rem, 2.2vw, 2rem);
    color: var(--white);
    margin: 0;
    text-align: left;
  }

  .details-title h2:after,
  .details-title h3:after {
    margin-left: 0;
    max-width: 17.5rem;
    width: 100%;
  }

  .details-title h2:before,
  .details-title h3:before {
    border-bottom-color: var(--red);
    width: 17.5rem;
    left: 0;
    right: auto;
  }

  .details-grid {
    display: grid;
    gap: 1.5rem;
    grid-template-columns: 1fr;
    width: 100%;
  }

  .details-grid p {
    margin: 0.4rem 0 0;
    white-space: pre-line;
    font-size: 1rem;
    line-height: 1.45;
    color: var(--white);
  }

  .label {
    font-weight: 700;
    text-transform: none;
    font-size: 1rem;
    letter-spacing: 0;
    color: #6eb4e0;
  }

  .details-image {
    width: 100%;
    line-height: 0;
    background: none;
  }

  .details-image img {
    width: 100%;
    height: auto;
    max-width: none;
    display: block;
    object-fit: cover;
  }

  @media (min-width: 992px) {
    /* vide gauche | texte | image | vide droite */
    .details-inner {
      grid-template-columns:
        minmax(80px, 12%)
        minmax(280px, 28%)
        minmax(0, 48%)
        minmax(80px, 12%);
      align-items: stretch;
      min-height: 520px;
    }

    .details-card {
      grid-column: 2;
      padding: 3rem clamp(1rem, 2.5vw, 2.5rem) 3rem 0;
      align-self: center;
    }

    .details-image {
      grid-column: 3;
      height: 100%;
      min-height: 520px;
      align-self: stretch;
    }

    .details-image img {
      width: 100%;
      height: 100%;
      min-height: 520px;
      object-fit: cover;
      object-position: center;
    }
  }
`;

export default NclCruiseSeptember2026Rsvp;
